// eslint-disable-next-line no-restricted-imports
import { useIntercom } from "react-use-intercom";

import { IntercomCustomAttributes } from "utils/intercom-types";

// Default attributes that should be included in all Intercom interactions
const DEFAULT_ATTRIBUTES: IntercomCustomAttributes = {
  product: "Forum V",
};

export const useIntercomWithDefaults = () => {
  const { show, update } = useIntercom();

  const showWithDefaults = () => {
    update({ customAttributes: DEFAULT_ATTRIBUTES });
    show();
  };

  const updateWithDefaults = (additionalAttributes: Partial<IntercomCustomAttributes> = {}) => {
    update({
      customAttributes: {
        ...DEFAULT_ATTRIBUTES,
        ...additionalAttributes,
      },
    });
  };

  return {
    showIntercom: showWithDefaults,
    updateIntercom: updateWithDefaults,
  };
};
